import { CASES } from '../EnumTypes/ActionEnumTypes';
import { getExternalUserCasesCounts as getExternalUserCasesCountsConnector } from 'Connectors/CaseConnector';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

const init = () => ({
    type: CASES.GET_EXTERNAL_USER_CASES_COUNTS_INIT,
});

const success = (data) => ({
    type: CASES.GET_EXTERNAL_USER_CASES_COUNTS_SUCCESS,
    payload: {
        data,
    },
});

const failure = () => ({
    type: CASES.GET_EXTERNAL_USER_CASES_COUNTS_FAILURE,
});

const getExternalUserCasesCounts = () => async (dispatch) => {
    dispatch(init());
    try {
        dispatch(ViewManagementModule.Actions.showLoader());
        const { data } = await getExternalUserCasesCountsConnector();
        dispatch(success(data));
        dispatch(ViewManagementModule.Actions.hideLoader());
    } catch (err) {
        dispatch(ViewManagementModule.Actions.hideLoader());
        dispatch(failure());
    }
};

export default getExternalUserCasesCounts;
